import React from "react";
import Select from "react-select/lib/Select";
import { TASK_STATUS_TYPES } from "./data";

export default function StatusComponent({ item, onDataChange, index }) {
  const handleOnChange = val => {
    onDataChange(index, val.value, "status");
  };
  return (
    <div style={{ flexGrow: 1 }}>
      <Select
        options={TASK_STATUS_TYPES}
        onChange={handleOnChange}
        value={item.status}
      />
    </div>
  );
}
